
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payments/failure",
      function () {
        return require("private-next-pages/payments/failure/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payments/failure"])
      });
    }
  